const PERMISSION_CONST = [
  {
    label: "Operators",
    color: "processing",
    keys: [
      { name: "Operator List View", key: "AGENT_READ_OPERATOR" },
      { name: "Operator Create", key: "AGENT_CREATE_OPERATOR" },
      { name: "Operator Edit", key: "AGENT_UPDATE_OPERATOR" },
      { name: "Operator Delete", key: "AGENT_DELETE_OPERATOR" },
    ],
  },
  {
    label: "Users",
    color: "gold",
    keys: [
      { name: "User List View", key: "AGENT_READ_USER" },
      { name: "User Create", key: "AGENT_CREATE_USER" },
      { name: "User Edit", key: "AGENT_UPDATE_USER" },
      { name: "User Delete", key: "AGENT_DELETE_USER" },
    ],
  },
  {
    label: "Avatars",
    color: "volcano",
    keys: [
      { name: "Avatar List View", key: "AGENT_READ_AVATAR" },
      { name: "Avatar Create", key: "AGENT_CREATE_AVATAR" },
      { name: "Avatar Edit", key: "AGENT_UPDATE_AVATAR" },
      { name: "Avatar Delete", key: "AGENT_DELETE_AVATAR" },
    ],
  },
  {
    label: "UI Design",
    color: "lime",
    keys: [{ name: "Agent Edit UI", key: "AGENT_UPDATE_UI" }],
  },
  {
    label: "Transaction",
    color: "magenta",
    keys: [
      { name: "Transaction List View", key: "AGENT_READ_USER_TRANSACTION" },
      { name: "Transaction Create", key: "AGENT_CREATE_USER_TRANSACTION" },
    ],
  },
  {
    label: "Agent Bank Account",
    color: "red",
    keys: [
      { name: "Agent Bank Account List View", key: "AGENT_READ_BANK_ACCOUNT" },
      { name: "Agent Bank Account Create", key: "AGENT_CREATE_BANK_ACCOUNT" },
      { name : "Agent Bank Account Edit", key : "AGENT_UPDATE_BANK_ACCOUNT"},
      { name: "Agent Bank Account Delete", key: "AGENT_DELETE_BANK_ACCOUNT" },
    ],
  },
  {
    label: "User Bank Account",
    color: "orange",
    keys: [
      { name: "User Bank Account List View", key: "AGENT_READ_USER_BANK_ACCOUNT" },
      { name: "User Bank Account Create", key: "AGENT_CREATE_USER_BANK_ACCOUNT" },
    ],
  },
  {
    label: "Social Media",
    color: "cyan",
    keys: [
      { name: "Social Media List View", key: "AGENT_READ_SOCIAL" },
      { name: "Social Media Create", key: "AGENT_CREATE_SOCIAL" },
      { name: "Social Media Edit", key: "AGENT_UPDATE_SOCIAL" },
      { name: "Social Media Delete", key: "AGENT_DELETE_SOCIAL" },
    ],
  },
  {
    label: "Promotion",
    color: "blue",
    keys: [
      { name: "Promotion List View", key: "AGENT_READ_PROMOTION" },
      { name: "Promotion Create", key: "AGENT_CREATE_PROMOTION" },
      { name: "Promotion Edit", key: "AGENT_UPDATE_PROMOTION" },
      { name: "Promotion Delete", key: "AGENT_DELETE_PROMOTION" },
    ],
  },
  {
    label: "Game Logs",
    color: "green",
    keys: [{ name: "Game Logs List View", key: "AGENT_READ_USER_GAME_LOGS" }],
  },

];

export { PERMISSION_CONST };
